import React, {useEffect} from 'react'
import Carousel from 'react-gallery-carousel'
import 'react-gallery-carousel/dist/index.css';


const Section5 = ({products, select, setSelect, setStep}) =>{

    let radios = products[select.material].option.radio;
    let checkboxes = products[select.material].option.checkbox;
    
    let bkgColors = products[select.material].properties.submaterial[select.submaterial].colors_bkg;
    let logoColors = products[select.material].properties.submaterial[select.submaterial].colors_logo;

    let colors_bkg_type = 0,
        colors_logo_type = 0

    if (radios !== false){
        radios = radios.filter((item) => { //remove empty or not correctly filled radio options
            if (isNaN(parseFloat(item.coef)) || isNaN(parseInt(item.to_basic_price)) || isNaN(parseInt(item.to_final_price))) {
                return false;
            } else {
                return true;
            }
        });
    }

    if (checkboxes !== false){
        checkboxes = checkboxes.filter((item) => { //remove empty or not correctly filled checkbox options
            if (isNaN(parseFloat(item.coef)) || isNaN(parseInt(item.to_basic_price)) || isNaN(parseInt(item.to_final_price))) {
                return false;
            } else {
                return true;
            }
        });
    }

    function onButtonClick(){

        if (radios.length > 0 && document.querySelector("#calc_radio_options input:checked") === null) {
            alert( window.lang['s5']['alert_select_finish']);
            return;
        }

        let mainColor = '';
        let otherColors = '';

        switch (colors_bkg_type) {
            case 10:
                mainColor = bkgColors[0].name
                break;
            case 20:
                mainColor = document.querySelector('input[name="bkgColor"]:checked')
                if (mainColor !== null) mainColor = mainColor.value
                break;
            case 30:
                mainColor = document.querySelector('#calc_main_color').value
                break;
                    
            default:
                console.log('bkg color mismatch', colors_bkg_type)
                return false;
        }

        switch (colors_logo_type) {
            case 1:
                otherColors = logoColors[0].name
                break;
            case 2:
                otherColors = document.querySelector('input[name="logoColor"]:checked')
                if (otherColors !== null) otherColors = otherColors.value
                break;
            case 3:
                otherColors = document.querySelector('#calc_other_colors').value
                break;
                    
            default:
                console.log('logo color mismatch', colors_logo_type)
                return false;
        }

        let tmpSelect = select;

        let i

        for (i = Object.keys(select.basicPrice).length; i >= 1;i--){
            delete  tmpSelect.basicPrice[Object.keys(select.basicPrice)[i]]
        }

        for (i = Object.keys(select.options).length; i >= 5 ;i--){
            delete  tmpSelect.options[Object.keys(select.options)[i]]
        }

        for (i = Object.keys(select.finalPrice).length; i >= 0 ;i--){
            delete  tmpSelect.finalPrice[Object.keys(select.finalPrice)[i]]
        }


        if (mainColor === '' || otherColors === '' || mainColor === null || otherColors === null){
            alert(window.lang['s5']['alert_colors']);
            return;
        }

        let selectedRadio = document.querySelector('#calc_radio_options input:checked');
        let selectedCheckboxes = document.querySelectorAll('#calc_checkbox_options input:checked');

        if (products[select.material].option.radio.length > 0 && selectedRadio !== null){
            let varName = document.querySelector(`label[for="${selectedRadio.id}"]`).textContent
            tmpSelect.options[`${varName}`] = parseFloat(selectedRadio.dataset.coef)
            tmpSelect.basicPrice[`${varName}`] = parseFloat(selectedRadio.dataset.tbp)
            tmpSelect.finalPrice[`${varName}`] = parseFloat(selectedRadio.dataset.tfp)
        };


        if (products[select.material].option.checkbox.length > 0 && selectedCheckboxes !== null){
            selectedCheckboxes.forEach((item, i) => {
                let varName = document.querySelector(`label[for="${item.id}"]`).textContent
                tmpSelect.basicPrice[`${varName}`] = parseFloat(item.dataset.tbp)
                tmpSelect.options[`${varName}`] = parseFloat(item.dataset.coef)
                tmpSelect.finalPrice[`${varName}`] = parseFloat(item.dataset.tfp)
            })
        }
        tmpSelect.created = ['order-', Math.floor(Date.now() / 1000)].join('')

        tmpSelect.optionNames = Object.getOwnPropertyNames(tmpSelect.options)
        
        if (products[select.material].properties.submaterial.length === 1)  {
            tmpSelect.optionNames.splice(0,5) //remove submaterial name if there is only one o_O
        }else{
            tmpSelect.optionNames.splice(0,4) 
        }

        /* additional coefs */

        let coefs = products[select.material].properties.additive_coeficients;

        if (coefs.by_count.value !== '' && select.amount >= parseInt(coefs.by_count.value) && select.cutStyle){
            tmpSelect.options.by_amount = parseFloat(coefs.by_count.coef)
        }

        if (coefs.by_count_rolls.value !== '' && select.amount >= parseInt(coefs.by_count_rolls.value) && !select.cutStyle){
            tmpSelect.options.by_amount = parseFloat(coefs.by_count.coef)
        }
        
        if (coefs.by_length.value !== '' && parseFloat(select.height) >= parseFloat(coefs.by_length.value)){
            tmpSelect.options.by_length = parseFloat(coefs.by_length.coef)
        }


        if (coefs.by_size.value !== '' && parseFloat(select.width) >= parseFloat(coefs.by_size.value)){
            tmpSelect.options.by_width = parseFloat(coefs.by_size.coef)
        }

        tmpSelect.colors.main = mainColor
        tmpSelect.colors.other = otherColors

        if (colors_logo_type === 3 && coefs.by_colors.value !== '' &&  tmpSelect.colors.other.split(' ').length >= parseInt(coefs.by_colors.value)){
            tmpSelect.options.by_color_count = parseFloat(coefs.by_colors.coef)
        }else if ( tmpSelect.options?.by_color_count){
            tmpSelect.options.by_color_count = 1
        }
        setSelect(tmpSelect)
        setStep(6)
    }

    function AdditionalOptions(){
        if (!radios && !checkboxes){
            return null;
        }
        return(
            <>
            <h3>{window.lang['s5']['subtitle_options']}</h3>
            <PrintRadios />
            <PrintCheckboxes />
            </>
        )
    }

    function PrintRadios(){
        if (radios){
            return(
            <div id="calc_radio_options">
                {radios.map((item,index) =>{
                    return(
                        <>
                        <span key={index}>
                            <label className='add_option_radio' htmlFor={'radiooption_' + index}>
                                <input  type="radio" 
                                        name="calc_radio_option" 
                                        id={'radiooption_' + index} 
                                        data-coef={item.coef} 
                                        data-tbp={item.to_basic_price} 
                                        data-tfp={item.to_final_price} 
                                        />
                                <span>{item.name}</span>
                            </label>
                        </span>
                        </>
                    )
                })}
            </div>
            )
        } else{
            return null;
        }
    }

    function checkPrintedRadios(){
        if (radios){
            let selectedRadio = document.querySelector('#calc_radio_options input:checked')
            if (selectedRadio === null){
                document.querySelector('#calc_radio_options input').checked = true
            }
        }
    }

    function PrintCheckboxes(){
        if (checkboxes){
            return(
            <div id="calc_checkbox_options">
                {checkboxes.map((item,index) =>{
                    return(
                        <>
                        <span key={index}>
                            <label className='add-option_cbx' htmlFor={'cbxoption_' + index}>
                                <input  type="checkbox" 
                                        name="calc_cbox_option" 
                                        id={'cbxoption_' + index} 
                                        data-coef={item.coef} 
                                        data-tbp={item.to_basic_price} 
                                        data-tfp={item.to_final_price} 
                                        key={index}
                                        />
                                <span>{item.name}</span>
                            </label>
                        </span>
                        </>
                    )
                })}
            </div>
            )
        }else{
            return null;
        }
    }

    function BkgColorSelector(){
        colors_bkg_type = 0;
        if (Array.isArray(bkgColors)){
            
            if (bkgColors.length === 1){
                colors_bkg_type +=10
                return(
                    <div className="color_no_options">
                        <span>{bkgColors[0].name}</span>
                        <div className="color_preview" style={{backgroundColor : bkgColors[0].color, height : '2em',width: '2em'}}></div>
                    </div>
                )
            }else{
                colors_bkg_type +=20
                let options = bkgColors.map((color,i) => {
                    return(
                        <>
                            <label key={i} htmlFor={`bkg_color_${i}`} style={{'--color' : color.color}}>
                                <input type="radio" name="bkgColor" id={`bkg_color_${i}`} value={color.name}/>
                                <div className="color-sample"></div>
                                {color.name}
                            </label>
                        </>
                    )
                })
                return (
                    <div className="color-options" id="bkgColor">
                        {options}
                    </div>
                )
            }
        }else{
            colors_bkg_type +=30
            return(
                <>
                    <span>{window.lang['s5']['note_print_color_name']}</span>
                    <input type="text" id="calc_main_color" placeholder={window.lang['s5']['placeholder_for_bkg']} />
                </>
            )
        }
        
    }

    function LogoColorSelector(){
        colors_logo_type = 0;
        if (Array.isArray(logoColors)){
            if (logoColors.length === 1){
                colors_logo_type +=1
                return(
                    <div className="color_no_options">
                        <span>{logoColors[0].name}</span>
                        <div className="color_preview" style={{backgroundColor : logoColors[0].color}}></div>
                    </div>
                )
            }else{
                colors_logo_type +=2
                let options = logoColors.map((color,i) => {
                    return(
                        <>
                            <label key={i} htmlFor={`logo_color_${i}`} style={{'--color' : color.color}}>
                                <input type="radio" name="logoColor" id={`logo_color_${i}`} value={color.name}/>
                                <div className="color-sample"></div>
                                {color.name}
                            </label>
                        </>
                    )
                })
                return (
                    <div className="color-options" id="logoColor">
                        {options}
                    </div>
                )
            }
        }else{
            colors_logo_type +=3
            return(
                <>
                    <span>{window.lang['s5']['note_print_color_name']}</span>
                    <div className="calc_other_colors__container">
                        <textarea id="calc_other_colors" rows="3" placeholder={window.lang['s5']['placeholder_for_logo']} />
                    </div>
                </>
            )
        }
    }

    function CarouselContainer(){
        let imgs = products[select.material].properties.submaterial[select.submaterial].colors
        if (imgs !== false){
            return(
                <div className="carousel-container">
                    <Carousel
                        images={imgs.map(item => {return {src: item}})}
                        isLoop={true} 
                        shouldLazyLoad={true}
                        hasSizeButton={false}
                        style={{backgroundColor:'transparent'}}
                        />
                </div>
            )
        }else{
            return (<div className="carousel-container">{window.lang['s5']['no_examples']}</div>)
        }
    }

    function goBack(){
        let tmpSelect = select

        let i

        for (i = Object.keys(select.basicPrice).length; i >= 1;i--){
            delete  tmpSelect.basicPrice[Object.keys(select.basicPrice)[i]]
        }

        for (i = Object.keys(select.options).length; i >= 5 ;i--){
            delete  tmpSelect.options[Object.keys(select.options)[i]]
        }

        for (i = Object.keys(select.finalPrice).length; i >= 0 ;i--){
            delete  tmpSelect.finalPrice[Object.keys(select.finalPrice)[i]]
        }

        tmpSelect.optionNames = []

        tmpSelect.options.by_amount = 1
        tmpSelect.options.by_length = 1
        tmpSelect.options.by_width = 1
        tmpSelect.options.by_color_count = 1

        tmpSelect.colors.main = ''
        tmpSelect.colors.other = ''

        setSelect(tmpSelect)
        setStep(4)
    }

    useEffect(() => {

        checkPrintedRadios()

        if (colors_logo_type === 2){
            document.querySelectorAll('#logoColor label').forEach((item) => {
                if (item.innerText === select.colors.other){
                    item.querySelector('input').checked = true
                }
            })
        }

        if (colors_bkg_type === 20){
            document.querySelectorAll('#bkgColor label').forEach((item) => {
                if (item.innerText === select.colors.main){
                    item.querySelector('input').checked = true
                }
            })
        }

        if (colors_logo_type === 3){
            document.querySelector('#calc_other_colors').value = select.colors.other
        }

        if (colors_bkg_type === 30){
            document.querySelector('#calc_main_color').value = select.colors.main
        }

        let options = document.querySelectorAll('#calc_checkbox_options label, #calc_radio_options label')
        if (options !== undefined && select.optionNames !== undefined && select.optionNames.length) {
            options.forEach((item) =>{
                if (select.optionNames.includes(item.innerText)){
                    item.querySelector('input').checked = true
                }}
        )}

    })

    return(
        <>
            <div className="section_header">
                <h1>{window.lang['s5']['title']}</h1>
                <div className="step-btns">
                    <button className="btn btn-prev" onClick={() => goBack()} ><span>{window.lang['s5']['btn_prev']}</span></button>
                    <button className="btn btn-next" onClick={() => onButtonClick()} ><span>{window.lang['s5']['btn_next']}</span></button>
                </div>
            </div>
            
            <div className="calc_color_select_container">

                <div className="color_options_container">
                    <h3>{window.lang['s5']['subtitle_bkg']}</h3>
                    <BkgColorSelector />
                    <h3>{window.lang['s5']['subtitle_logo']}</h3>
                    <LogoColorSelector />
                </div>

                <CarouselContainer />

                <div className="calc-additional-options">
                    <AdditionalOptions />
                </div>

            </div>
            <div className="step-btns">
                    <button className="btn btn-prev" onClick={() => goBack()} ><span>{window.lang['s5']['btn_prev']}</span></button>
                    <button className="btn btn-next" onClick={() => onButtonClick()} ><span>{window.lang['s5']['btn_next']}</span></button>
            </div>
        </>
    );
}

export default Section5;